import { registerPlugin } from '@capacitor/core';

interface IMParticleAttPlugin {
  updateATTStatus: () => Promise<void>;
}

export const MParticleATTPlugin = registerPlugin<IMParticleAttPlugin>('MParticleATTPlugin');
